import React, { FC } from 'react';
import { useHistory } from 'react-router';
import { Formik, Form as FormikForm } from 'formik';
import { useTranslation } from 'react-i18next';

import { CreateGroupInput, CreateGroupMutation, useCreateGroupMutation } from 'api';
import { Layouts } from 'components';
import { useNotify } from 'hooks';
import { CREATE_GROUP_INITIAL_VALUES } from 'features/groups';

import { GroupDataProvider } from '../providers';
import { useCreateGroup } from '../updaters';
import { GroupForm } from '../components/Edit';
import { GroupSchema } from '../validations';

const CreateGroup: FC = () => {
  const { t } = useTranslation();
  const notify = useNotify();
  const history = useHistory();

  const createGroupMutationOptions = useCreateGroup();
  const { mutate, isLoading } = useCreateGroupMutation({
    onSuccess: handleCompleted,
    ...createGroupMutationOptions,
  });

  function handleSubmit(values: CreateGroupInput) {
    mutate({ data: values });
  }

  function handleCompleted(data: CreateGroupMutation) {
    const { createGroup } = data;

    const message = t('groups:createGroupSuccess', { name: createGroup.title });
    notify.info({ message });
    history.push(`/group/${createGroup.id}/edit`);
  }

  function renderMain() {
    return (
      <GroupDataProvider>
        <Formik
          onSubmit={handleSubmit}
          initialValues={CREATE_GROUP_INITIAL_VALUES}
          validationSchema={GroupSchema}
        >
          <FormikForm>
            <GroupForm action="create" isWorking={isLoading} />
          </FormikForm>
        </Formik>
      </GroupDataProvider>
    );
  }

  return <Layouts.App1Column navigation desktopSize={12} main={renderMain()} />;
};

export default CreateGroup;
